import { IEquipmentMaintenanceBlank } from '../../../equipment.types.ts'
import useMaintenanceBlankSchema from '../../../../Processes/Maintenance/hooks/useMaintenanceBlankSchema.ts'
import SidePage from '../../../../../shared/SidePage'
import timeUtils from '../../../../../utils/time.utils.ts'
import Tag from '../../../../../shared/Tags/Tag'
import SeparateLine from '../../../../../shared/Forms/SeparateLine'
import css from './maintenanceBlankSidePage.module.css'
import Tabs from '../../../../../shared/Tabs'
import { useMemo, useState } from 'react'
import { ITab } from '@/shared/Tabs/tabs.types.ts'
import EquipmentMaintenanceSidePageFilesContent from './EquipmentMaintenanceSidePageFilesContent'
import BadgeCount from '../../../../../shared/Badges/BadgeCount'
import BasicTable from '@/shared/Tables/BasicTable/index.tsx'
import userUtils from '@/pages/User/user.utils.ts'

interface IProps {
  open: boolean
  blank: IEquipmentMaintenanceBlank
  onClose: () => void
}

const EquipmentMaintenanceBlankSidePage = (props: IProps) => {
  const blankSchema = useMaintenanceBlankSchema(props.blank.blankSchemaId)
  const [tab, setTab] = useState(props.blank.type === 'PLANNED' ? 'blank' : 'files')

  const tabs: ITab[] = useMemo(() => {
    const filesTabTile = (
      <div className="inline-flex-gap center gap8">
        <span className="text-nm" style={{ color: 'inherit' }}>
          Прикрепленные файлы
        </span>
        <BadgeCount type="default" count={props.blank.files.length} />
      </div>
    )

    if (props.blank.type === 'PLANNED') {
      return [
        { title: 'Бланк ТО', id: 'blank' },
        { title: filesTabTile, id: 'files' },
      ]
    }

    return [{ title: filesTabTile, id: 'files' }]
  }, [props.blank])

  const renderTabContent = () => {
    switch (true) {
      case tab === 'blank' && Boolean(blankSchema?.fields):
        return (
          <div className="flex-lines gap16" style={{ overflow: 'auto', flex: '1 1 0%', paddingRight: '18px' }}>
            {blankSchema.fields.map((fieldSchema, index) => (
              <div key={fieldSchema.id} className={css.fieldSchemaContainer}>
                <div className="flex-space-between">
                  <h3 className="text-heading-5">{fieldSchema.name}</h3>
                </div>
                <BasicTable
                  columns={['Содержание работ', 'Технические требования', 'Комментарий']}
                  values={[
                    [
                      <span className="text-nm" style={{ whiteSpace: 'pre-wrap' }}>
                        {fieldSchema.instruction}
                      </span>,
                      <span className="text-nm" style={{ whiteSpace: 'pre-wrap' }}>
                        {fieldSchema.requirements}
                      </span>,
                      <span className="text-nm" style={{ whiteSpace: 'pre-wrap' }}>
                        {props.blank.values[index].value}
                      </span>,
                    ],
                  ]}
                />
              </div>
            ))}
          </div>
        )
      default:
        return <EquipmentMaintenanceSidePageFilesContent files={props.blank.files} />
    }
  }

  const renderTags = () => {
    switch (props.blank.type) {
      case 'PLANNED':
        return (
          <div className="inline-flex-gap gap12">
            <Tag color="gray">
              <span className="text-caption">Плановое</span>
            </Tag>
            <Tag color="green">
              <span className="text-caption">Выполнено</span>
            </Tag>
          </div>
        )
      default:
        return (
          <Tag color="red">
            <span className="text-caption">Внеплановое</span>
          </Tag>
        )
    }
  }

  return (
    <SidePage onClose={props.onClose} open={props.open} size="large" style={{ paddingRight: '0' }}>
      <div className="flex-lines gap16" style={{ height: '100%' }}>
        <div className="flex-lines gap12" style={{ paddingRight: '24px' }}>
          {renderTags()}
          <h2 className="text-heading-4">{props.blank.type === 'PLANNED' ? blankSchema.name : 'Внеплановое ТО'}</h2>
        </div>
        <div className="flex-lines gap16" style={{ paddingRight: '24px' }}>
          <SeparateLine />
          <h5 className="text-heading-5">Общая информация</h5>
          <div className={css.maintenanceBlankSidePageGrid}>
            <p className="text-nm text-secondary">Дата обслуживания:</p>
            <p className="text-nm">{timeUtils.formatDate(new Date(props.blank.createdAt), 'dd MMM yyyy HH:mm:ss')}</p>
            <p className="text-nm text-secondary">Тип обслуживания:</p>
            <p className="text-nm">{props.blank.type === 'PLANNED' ? 'Плановое' : 'Внеплановое'}</p>
            <p className="text-nm text-secondary">Комментарий:</p>
            <p className="text-nm">{props.blank.comment}</p>
            <p className="text-nm text-secondary">Выполнивший ТО:</p>
            <p className="text-nm text-link" style={{ textDecoration: 'none' }}>
              {userUtils.getFullName(props.blank.createdBy.userInfo)}
            </p>
          </div>
          <SeparateLine />
          <Tabs tabs={tabs} onSelect={setTab} selectedTab={tab} />
        </div>
        {renderTabContent()}
      </div>
    </SidePage>
  )
}

export default (props: IProps) => {
  if (!props.blank) return null

  return <EquipmentMaintenanceBlankSidePage {...props} />
}
